import React, { Component } from 'react';
import { Link } from 'react-router';
import { fieldDateFormat, backendDateFormat, numberRegx } from '../../../../constants';
import { regexConstants } from '../../../../constants/regEx';
export default class UtilsFields extends Component{
  constructor(props){
    super(props);
    this.state = {
      value:''
    }
  }
  componentDidMount(){
    this.setState({
      value: this.props.value
    });
  }
  componentWillReceiveProps(nextProps){

    // if(this.props.value != nextProps.value){
      this.setState({
        value: nextProps.value
      });
    // }
  }
  changeUtil = (value, e) => {
    if(this.props.keyParam == 'asset_location' || this.props.keyParam == 'remarks' || this.props.keyParam == 'serviceability' ){
      this.setState({
        value: value
      });
    }else if(this.props.keyParam == 'egt_margin' ){
      if(value < 100000 && value > -100000 || value =="-"){
        if(value =='-'? true: regexConstants.numeric5DigitWithDotNegative.test(value)){
          this.setState({
            value: value
          });
        }else{
          e.preventDefault()
        }
      } else{
        e.preventDefault()
      }
    }
    else{
      if(numberRegx.test(parseFloat(value)) || value == ''){
        this.setState({
          value: value
        });
      }
    }
  }
  updateUtil = () => {
    this.props.updateUtilField(this.props.index, this.state.value, this.props.keyParam, this.props.asset);
  }
  render(){
    const { index, label, width, type, accept } = this.props;
    if(type == 'textArea'){
      return(
        <div className="form-group">
          <textarea
            rows="3"
            type="text"
            maxLength={this.props.maxLength}
            value={this.state.value !== undefined && this.state.value !== null ? this.state.value:''}
            onChange={(e) => this.changeUtil(e.target.value)}
            onBlur={this.updateUtil}
            style={{width: width}}
            disabled={this.props?.disabled}
          ></textarea>
        </div>
      )
    }else{
      return(
        <div className="form-group">
          <input
            type="text"
            maxLength={this.props.maxLength}
            value={this.state.value !== undefined && this.state.value !== null ? this.state.value:''}
            onChange={(e) => this.changeUtil(e.target.value, e)}
            onBlur={this.updateUtil}
            onFocus={this.props?.onFocus}
            style={{width: width}}
            disabled={this.props?.disabled}
          />
        </div>
      )
    }

  }
}
